module.exports = __webpack_public_path__ + "media/application/images/2018/icon-recommended-430ed33d234348ba69910a0945e6757c.svg";